// // import { useEffect, useState } from "react";
// // import { getCompanyById } from "../../services/companyService";

// // const AppliedJobs = ({ jobs }) => {
// //   const [companyInfo, setCompanyInfo] = useState({});

// //   useEffect(() => {
// //     if (jobs.length > 0) {
// //       jobs.forEach(async (job) => {
// //         // console.log("Fetching company details for:", job.companyId);
// //         if (job.companyId) {
// //           try {
// //             const company = await getCompanyById(job.companyId);
// //             // console.log("Fetched company data:", company);
// //             // console.log(company.logo)
// //             setCompanyInfo((prev) => ({ ...prev, [job.companyId]: company }));
// //           } catch (error) {
// //             console.error("Error fetching company:", error);
// //           }
// //         }
// //       });
// //     }
// //   }, [jobs]);

// //   return (
// //     <div className="p-4">
// //       <h2 className="text-xl font-semibold mb-4">Applied Jobs</h2>
// //       {jobs.length === 0 ? (
// //         <p className="text-gray-500">No applied jobs yet.</p>
// //       ) : (
// //         <div className="space-y-4">
// //           {jobs.map((job) => (
// //             <div key={job.id} className="p-4 border bg-gray-100 rounded-lg shadow-sm">
// //               <div className="flex items-center space-x-4">
// //                 {companyInfo[job.companyId]?.logo ? (
// //                   <img
// //                     src={companyInfo[job.companyId].logo}
// //                     alt={companyInfo[job.companyId]?.name || "Company"}
// //                     className="w-10 h-10 object-contain rounded-full"
// //                   />
// //                 ) : (
// //                   <div className="w-10 h-10 flex items-center justify-center bg-red-300 text-white rounded-full text-sm font-semibold">
// //                     {companyInfo[job.companyId]?.name?.slice(0, 2).toUpperCase() || "NA"}
// //                   </div>
// //                 )}

// //                 <div>
// //                   <h3 className="font-semibold">{job.jobTitle || "Job Title"}</h3>
// //                   <p className="text-gray-500">
// //                     {companyInfo[job.companyId]?.name || "Unknown Company"}
// //                   </p>
// //                   <p className="text-sm text-blue-600">{job.status || "Applied"}</p>
// //                 </div>
// //               </div>

// //               {/* Applied Date Section */}
// //               <div className="mt-3">
// //                 <p className="text-sm text-gray-500">
// //                   <span className="text-green-500 mr-1">Applied:</span>
// //                   {job.postedAt
// //                     ? new Date(job.postedAt.seconds * 1000).toLocaleDateString("en-GB")
// //                     : "N/A"}
// //                 </p>
// //               </div>

// //             </div>
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default AppliedJobs;





import { useEffect, useState } from "react";
import { getCompanyById } from "../../services/companyService";

const AppliedJobs = ({ jobs }) => {
  const [companyInfo, setCompanyInfo] = useState({});

  useEffect(() => {
    if (jobs.length > 0) {
      jobs.forEach(async (job) => {
        if (job.companyId) {
          try {
            const company = await getCompanyById(job.companyId);
            setCompanyInfo((prev) => ({ ...prev, [job.companyId]: company }));
          } catch (error) {
            console.error("Error fetching company:", error);
          }
        }
      });
    }
  }, [jobs]);

  // Function to get status styling based on application status
  const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
      case "applied":
        return "bg-blue-100 text-blue-800";
      case "processing":
        return "bg-yellow-100 text-yellow-800";
      case "shortlisted":
        return "bg-green-100 text-green-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Function to get candidate status from job candidates array
  const getCandidateStatus = (job, candidateId) => {
    if (!job.candidates || !candidateId) return "Applied";
    const candidate = job.candidates.find(c => c.id === candidateId);
    return candidate?.hiringStatus || candidate?.status || "Applied";
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Applied Jobs</h2>
      {jobs.length === 0 ? (
        <p className="text-gray-500">No applied jobs yet.</p>
      ) : (
        <div className="space-y-4">
          {jobs.map((job) => {
            const candidateStatus = getCandidateStatus(job, job.candidateId);
            const statusStyle = getStatusStyle(candidateStatus);

            return (
              <div key={job.id} className="p-4 border bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-start space-x-4">
                  {/* Company Logo */}
                  {companyInfo[job.companyId]?.logo ? (
                    <img
                      src={companyInfo[job.companyId].logo}
                      alt={companyInfo[job.companyId]?.name || "Company"}
                      className="w-12 h-12 object-contain rounded-full border border-gray-200"
                    />
                  ) : (
                    <div className="w-12 h-12 flex items-center justify-center bg-gray-200 text-gray-600 rounded-full text-sm font-semibold">
                      {companyInfo[job.companyId]?.name?.slice(0, 2).toUpperCase() || "CO"}
                    </div>
                  )}

                  {/* Job Details */}
                  <div className="flex-1">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-semibold text-lg">{job.jobTitle || "Job Title"}</h3>
                        <p className="text-gray-600">
                          {companyInfo[job.companyId]?.name || "Unknown Company"}
                        </p>
                      </div>
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${statusStyle}`}>
                        {candidateStatus}
                      </span>
                    </div>

                    {/* Job Metadata */}
                    <div className="mt-2 flex flex-wrap gap-4 text-sm text-gray-500">
                      {job.location && (
                        <div className="flex items-center">
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          {job.location}
                        </div>
                      )}
                      {job.salary && (
                        <div className="flex items-center">
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          {job.salary}
                        </div>
                      )}
                      {job.jobType && (
                        <div className="flex items-center">
                          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                          {job.jobType}
                        </div>
                      )}
                    </div>

                    {/* Application Timeline */}
                    <div className="mt-3 pt-3 border-t border-gray-100">
                      <div className="flex justify-between text-sm">
                        <div>
                          <p className="text-gray-500">Applied</p>
                          <p className="font-medium">
                            {job.appliedAt
                              ? new Date(job.appliedAt).toLocaleDateString("en-GB")
                              : job.postedAt?.seconds
                              ? new Date(job.postedAt.seconds * 1000).toLocaleDateString("en-GB")
                              : "N/A"}
                          </p>
                        </div>
                        {job.expiryDate && (
                          <div className="text-right">
                            <p className="text-gray-500">Deadline</p>
                            <p className="font-medium">
                              {new Date(job.expiryDate).toLocaleDateString("en-GB")}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AppliedJobs;


